var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWatchlistThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.614 0 0 7.614 0 17s7.614 17 17 17 17-7.614 17-17S26.386 0 17 0",
    fill: "#E5E5E7",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.08 22.443H8.272a.61.61 0 00-.602.602c0 .3.301.6.602.6h2.808v2.809a.61.61 0 00.602.602.61.61 0 00.601-.602v-2.808h2.808a.61.61 0 00.602-.601c0-.301-.3-.602-.602-.602h-2.808v-2.808a.61.61 0 00-.6-.602.61.61 0 00-.603.602v2.808zm.602 5.679c-2.89 0-5.262-2.261-5.262-5.077 0-2.78 2.371-5.077 5.262-5.077 2.89 0 5.262 2.26 5.262 5.077.037 2.816-2.335 5.077-5.262 5.077zm9.967-6.56a.353.353 0 01-.348.349h-2.905c-.059-.261-.06-.494-.177-.726h3.053c.232.029.377.203.377.378zm-9.735-7.177a.353.353 0 00-.348.349c0 .203.174.348.348.348h9.387a.353.353 0 00.348-.348.353.353 0 00-.348-.35h-9.387zm4.693 4.097h4.694a.353.353 0 00.348-.348.353.353 0 00-.348-.35h-5.548l.854.698zm10.1-7.032l-2.878 11.478v1.802c0 .407-.32.727-.698.727h-5.963c.145-.233.262-.465.35-.727h5.613V11.653H10.113v5.696c-.233.087-.494.175-.698.29v-6.015c0-.407.32-.726.698-.726h1.83l.727-2.935a.883.883 0 011.075-.64l12.292 3.052a.88.88 0 01.67 1.075z"
  })));
}

export default SvgWatchlistThumb;